// // assets
// // import { CableIcon, IconDetails,IconTable } from '@tabler/icons';
// import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
// import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
// import AutoModeIcon from '@mui/icons-material/AutoMode';
// import SmartphoneIcon from '@mui/icons-material/Smartphone';
// import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
// import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
// import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
// import TtyIcon from '@mui/icons-material/Tty';
// import HomeIcon from '@mui/icons-material/Home';
// import StarIcon from '@mui/icons-material/Star';
// import MenuBookIcon from '@mui/icons-material/MenuBook';

// // constant
// const icons = {HomeIcon,TtyIcon,StarIcon,MenuBookIcon};

// // ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

// const other = {
//     id: 'sample-docs-roadmap',
//     type: 'group',
//     children: [
//         {
//             id: 'sample-page1',
//             title: 'Home',
//             type: 'item',
//              url: '',
//              icon:HomeIcon,
//             breadcrumbs: true,
//             children: [
//                 {
//                     id: 'sample-page5',
//                     title: 'Off Road Vehicle',
//                     type: 'collapse',
//                     url: '/reusable',
//                     icon: icons.DisplaySettingsIcon,
//                     breadcrumbs: true,
//                     children: [
//                         {
//                             id: 'sample-page5',
//                             title: 'Fleet',
//                             type: 'item',
//                             url: '/filtersearch',
//                             icon: icons.DisplaySettingsIcon,
//                             breadcrumbs: true
//                         }]
//                 },
//                 // {
//                 //     id: 'sample-page6',
//                 //     title: 'Industrial - Automation Systems',
//                 //     type: 'item',
//                 //     url: '/page1',
//                 //     icon: icons.AutoModeIcon,
//                 //     breadcrumbs: true
//                 // },
//                 {
//                     id: 'sample-page7',
//                     title: 'Manufacturing Engineering',
//                     type: 'item',
//                     url: '/page2',
//                     icon: icons.PrecisionManufacturingIcon,
//                     breadcrumbs: true
//                 },
//                 {
//                     id: 'sample-page8',
//                     title: 'Information Systems Solutions',
//                     type: 'item',
//                     url: '/page3',
//                     icon: icons.SmartphoneIcon,
//                     breadcrumbs: true
//                 },
//                 {
//                     id: 'table',
//                     title: 'Powertrain',
//                     type: 'item',
//                     url: '/table',
//                     icon: icons.IconTable,
//                     breadcrumbs: true
//                 },
//                 {
//                     id: 'reusable',
//                     title: 'Commercial Vehicle',
//                     type: 'item',
//                     url: '/tabs',
//                     icon: icons.IconDetails,
//                     breadcrumbs: true
//                 },
//                 {
//                     id: 'manufacture',
//                     title: 'Manufacture Engineering',
//                     type: 'item',
//                     url: '/manufacture',
//                     icon: icons.IconDetails,
//                     breadcrumbs: true
//                 },
//                 {
//                     id: 'software',
//                     title: 'Display system',
//                     type: 'item',
//                     url: '/software',
//                     icon: icons.IconDetails,
//                     breadcrumbs: true
//                 }
//             ]
//         },
//         {
//             id: 'sample-page2',
//             title: 'About Us',
//             type: 'item',
//              url: '/carousel',
//              icon:MenuBookIcon,
//             breadcrumbs: true
//         },
//         {
//             id: 'sample-page3',
//             title: 'Favorites',
//             type: 'item',
//              url: '/breadcrumb',
//              icon:StarIcon,
//             breadcrumbs: true
//         },
//         {
//             id: 'sample-page4',
//             title: 'Contact Us',
//             type: 'item',
//              url: '/dashboard',
//             icon: TtyIcon,
//             breadcrumbs: true
//         },
//         // {
//         //     id: 'sample-page5',
//         //     title: 'Display - Systems Solutions',
//         //     type: 'item',
//         //      url: '/reusable',
//         //     icon: icons.DisplaySettingsIcon,
//         //     breadcrumbs: false
//         // },
//         // {
//         //     id: 'sample-page6',
//         //     title: 'Industrial - Automation Systems',
//         //     type: 'item',
//         //      url: '/reusable',
//         //     icon: icons.AutoModeIcon,
//         //     breadcrumbs: false
//         // },
//         // {
//         //     id: 'sample-page7',
//         //     title: 'Manufacturing Engineering',
//         //     type: 'item',
//         //      url: '/reusable',
//         //     icon: icons.PrecisionManufacturingIcon,
//         //     breadcrumbs: false
//         // },
//         // {
//         //     id: 'sample-page8',
//         //     title: 'Information Systems Solutions',
//         //     type: 'item',
//         //      url: '/reusable',
//         //     icon: icons.SmartphoneIcon,
//         //     breadcrumbs: false
//         // },
//         // {
//         //     id: 'table',
//         //     title: 'Tables',
//         //     type: 'item',
//         //     url: '/table',
//         //     icon: icons.IconTable,
//         //     breadcrumbs: false
//         // },
//         // {
//         //     id: 'reusable',
//         //     title: 'OffRoad Vehicle',
//         //     type: 'item',
//         //     url: '/reusable',
//         //     icon: icons.IconDetails,
//         //     breadcrumbs: false
//         // }
//     ]
// };

// export default other;

// // // assets
// // import { CableIcon, IconDetails, IconTable } from '@tabler/icons';

// // // constant
// // const icons = { CableIcon, IconDetails, IconTable };

// // // ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

// // const other = {
// //     id: 'sample-docs-roadmap',
// //     type: 'group',
// //     children: [
// //         {
// //             id: 'sample-page',
// //             title: 'Dashboard',
// //             type: 'collapse',
// //             icon: icons.CableIcon,
// //             breadcrumbs: false,
// //         children: [
// //             {
// //                 id: 'sample-page',
// //                 title: 'Dashboard',
// //                 type: 'item',
// //                  url: '/reusable',
// //                 target: true
// //             },
// //                 {
// //                     id: 'reusable',
// //                     title: 'OffRoad Vehicle',
// //                     type: 'item',
// //                     url: '/reusable',
// //                     target: true
// //                 },
// //             ]
// //         }
// //     ]
// // };

// // export default other;




// // assets
// // import { CableIcon, IconDetails,IconTable } from '@tabler/icons';
// import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
// import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
// import AutoModeIcon from '@mui/icons-material/AutoMode';
// import SmartphoneIcon from '@mui/icons-material/Smartphone';
// import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
// import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
// import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
// import TtyIcon from '@mui/icons-material/Tty';
// import HomeIcon from '@mui/icons-material/Home';
// import StarIcon from '@mui/icons-material/Star';
// import MenuBookIcon from '@mui/icons-material/MenuBook';

// // constant
// const icons = { HomeIcon, TtyIcon, StarIcon, MenuBookIcon };

// // ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

// const other = {
//     id: 'sample-docs-roadmap',
//     type: 'group',
//     children: [
//         {
//              id: 'sample-page1',
//              title: 'Devices',
//              type: 'collapse',
//              url: '/homepage',
//              icon: HomeIcon,
//              breadcrumbs: true,
//             children: [
//                 // {
//                 //     id: 'sample-page5',
//                 //     title: 'OffRoad Vehicle Systems',
//                 //     type: 'collapse',
//                 //     url: '/reusable',
//                 //     icon: icons.DisplaySettingsIcon,
//                 //     breadcrumbs: true,
//                 //     children: [
//                 //         {
//                 //             id: 'sample-page5',
//                 //             title: 'Fleet',
//                 //             type: 'item',
//                 //             url: '/reusable',
//                 //             icon: icons.DisplaySettingsIcon,
//                 //             breadcrumbs: true
//                 //         }]
//                 // },
//                 {
//                     id: 'sample-page5',
//                     title: 'List',
//                     type: 'item',
//                     url: '/reusable',
//                     icon: icons.AutoModeIcon,
//                     breadcrumbs: true
//                 },
//                 {Conf
//                     id: 'table',
//                     title: 'ig',
//                     type: 'item',
//                     url: '/page1',
//                     icon: icons.IconTable,
//                     breadcrumbs: true
//                 },
//                 {
//                     id: 'reusable',
//                     title: 'Status',
//                     type: 'item',
//                     url: '/page2',
//                     icon: icons.IconDetails,
//                     breadcrumbs: true
//                 },
//                 // {
//                 //     id: 'electrical',
//                 //     title: 'Electrical - Electronic Systems',
//                 //     type: 'item',
//                 //     url: '/page3',
//                 //     icon: icons.IconDetails,
//                 //     breadcrumbs: true
//                 // },
//                 // {
//                 //     id: 'software',
//                 //     title: 'Display System Solutions',
//                 //     type: 'item',
//                 //     url: '/table',
//                 //     icon: icons.IconDetails,
//                 //     breadcrumbs: true
//                 // },
//                 // {
//                 //     id: 'sample-page6',
//                 //     title: 'Industrail Automation Systems',
//                 //     type: 'item',
//                 //     url: '/tabs',
//                 //     icon: icons.AutoModeIcon,
//                 //     breadcrumbs: true
//                 // },
//                 // {
//                 //     id: 'sample-page7',
//                 //     title: 'Manufacturing Engineering',
//                 //     type: 'item',
//                 //     url: '/manufacture',
//                 //     icon: icons.PrecisionManufacturingIcon,
//                 //     breadcrumbs: true
//                 // },
//                 // {
//                 //     id: 'sample-page8',
//                 //     title: 'Information System and Solutions',
//                 //     type: 'item',
//                 //     url: '/software',
//                 //     icon: icons.SmartphoneIcon,
//                 //     breadcrumbs: true
//                 // },

//             ]
//         },
//         // {
//         //     id: 'sample-page2',
//         //     title: 'About Us',
//         //     type: 'item',
//         //     url: '/carousel',
//         //     icon: MenuBookIcon,
//         //     breadcrumbs: true
//         // },
//         // {
//         //     id: 'sample-page3',
//         //     title: 'Favorites',
//         //     type: 'item',
//         //     url: '/sample-page',
//         //     icon: StarIcon,
//         //     breadcrumbs: true
//         // },
//         // {
//         //     id: 'sample-page4',
//         //     title: 'Contact Us',
//         //     type: 'item',
//         //     url: '/dashboard',
//         //     icon: TtyIcon,
//         //     breadcrumbs: true
//         // },

//         {
//             id: 'sample-page3',
//              title: 'Settings',
//             type: 'collapse',
//             url: '',
//            //  icon: HomeIcon,
//             breadcrumbs: true,
//            children: [

//                   {
//                     id: 'sample-page5',
//                      title: 'Operational',
//                     type: 'item',
//                     url: '/reusable',
//                     // icon: icons.AutoModeIcon,
//                     breadcrumbs: true
//                  },
//               {
//                   id: 'table',
//                    title: 'Maintenance',
//                type: 'item',
//                     url: '/page1',
//                    // icon: icons.IconTable,
//                  breadcrumbs: true
//              },
//     //            {
//     //                id: 'reusable',
//     //                title: 'Real-time monitoring',
//     //                type: 'item',
//     //                url: '/page2',
//     //                // icon: icons.IconDetails,
//     //                breadcrumbs: true
//     //            },
//     //            {
//     //             id: 'reusable',
//     //             title: 'Thresholds',
//     //             type: 'item',
//     //             url: '/page2',
//     //             // icon: icons.IconDetails,
//     //             breadcrumbs: true
//     //         },
//     //         {
//     //             id: 'reusable',
//     //             title: 'Alerts',
//     //             type: 'item',
//     //             url: '/page2',
//     //             // icon: icons.IconDetails,
//     //             breadcrumbs: true
//     //         },
//             ]
//         },
// //        {
// //         id: 'sample-page1',
// //         title: 'Dashboards',
// //         type: 'collapse',
// //         url: '',
// //        //  icon: HomeIcon,
// //         breadcrumbs: true,
// //        children: [

// //            {
// //                id: 'sample-page5',
// //                title: 'Operational dashboards-Costs(fuel,elect,man,mater),Outputs',
// //                type: 'item',
// //                url: '/reusable',
// //                // icon: icons.AutoModeIcon,
// //                breadcrumbs: true
// //            },
// //            {
// //                id: 'table',
// //                title: 'Live Meters/Gauges',
// //                type: 'item',
// //                url: '/page1',
// //                // icon: icons.IconTable,
// //                breadcrumbs: true
// //            },
// //            {
// //                id: 'reusable',
// //                title: 'Efficiency-Output,uptime,downtime',
// //                type: 'item',
// //                url: '/page2',
// //                // icon: icons.IconDetails,
// //                breadcrumbs: true
// //            },
// //            {
// //             id: 'reusable',
// //             title: 'Maintenance-daily,monthly,quarterly maintenance dashboard',
// //             type: 'item',
// //             url: '/page2',
// //             // icon: icons.IconDetails,
// //             breadcrumbs: true
// //         },

// //        ]
// //    },
// //   
//  ]



// };

// export default other;
// assets
// import { CableIcon, IconDetails,IconTable } from '@tabler/icons';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import TtyIcon from '@mui/icons-material/Tty';
import HomeIcon from '@mui/icons-material/Home';
import StarIcon from '@mui/icons-material/Star';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import DevicesIcon from '@mui/icons-material/Devices';
import SettingsIcon from '@mui/icons-material/Settings';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
// constant
const icons = { HomeIcon, TtyIcon, StarIcon, MenuBookIcon };

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const other = {
    id: 'sample-docs-roadmap',
    type: 'group',

    children: [
        {
            id: 'sample-page1',
            title: 'Dashboards',
            type: 'collapse',
            url: '/homepage',
            //  icon: HomeIcon,
            icon: DashboardIcon,
            breadcrumbs: true,
            children: [
                {
                    id: 'sample-page2',
                    title: 'Operations',
                    type: 'item',
                    url: '/dashboard',
                    // icon: MenuBookIcon,
                    breadcrumbs: true
                },
                {
                    id: 'sample-page9',
                    title: 'Live Meters',
                    type: 'item',
                    url: '/operation',
                    icon: icons.PrecisionManufacturingIcon,
                    breadcrumbs: true
                },
                {
                    id: 'sample-page3',
                    title: 'Efficiency',
                    type: 'item',
                    url: '/Efficiency',
                    //  icon: StarIcon,
                    breadcrumbs: true
                },
                {
                    id: 'sample-page4',
                    title: 'Maintenance',
                    type: 'item',
                    url: '/LiveMeters',
                    //    icon: TtyIcon,
                    breadcrumbs: true
                },

            ]
        },
        {
            id: 'sample-page2',
            title: 'Devices',
            type: 'collapse',
            url: '/homepage',
            //  icon: HomeIcon,
            icon: DevicesIcon,

            breadcrumbs: true,
            children: [

                {
                    id: 'sample-page5',
                    title: 'List',
                    type: 'item',
                    url: '/List',
                    icon: icons.AutoModeIcon,
                    breadcrumbs: true
                },

                {
                    id: 'table',
                    title: 'Config',
                    type: 'item',
                    url: '/carousel',
                    icon: icons.IconTable,
                    breadcrumbs: true
                },
                //    {
                //        id: 'reusable',
                //        title: 'Status',
                //        type: 'item',
                //        url: '/page2',
                //        icon: icons.IconDetails,
                //        breadcrumbs: true
                //    },
                {
                    id: 'reusable',
                    title: 'Status',
                    type: 'item',
                    url: '/Status',
                    icon: icons.IconDetails,
                    breadcrumbs: true
                },
            ]
        },
        {
            id: 'sample-page3',
            title: 'User',
            type: 'collapse',
            url: '/homepage',

            icon: PeopleIcon,

            breadcrumbs: true,
            children: [

                {
                    id: 'sample-page5',
                    title: 'Role',
                    type: 'item',
                    url: '/Dial',
                    icon: icons.AutoModeIcon,
                    breadcrumbs: true
                },

                {
                    id: 'table',
                    title: 'Manage',
                    type: 'item',
                    url: '/Manage',
                    icon: icons.IconTable,
                    breadcrumbs: true
                },

            ]
        },
        {
            id: 'sample-page4',
            title: 'Settings',
            type: 'collapse',
            url: '/homepage',
            // icon: HomeIcon,
            icon: SettingsIcon,
            breadcrumbs: true,
            children: [
                // {
                //     id: 'electrical',
                //     title: 'Operational',
                //     type: 'item',
                //     url: '/dashboard',
                //     icon: icons.IconDetails,
                //     breadcrumbs: true
                // },
                {
                    id: 'software',
                    title: 'Maintenance',
                    type: 'item',
                    url: '/LiveMeters',
                    icon: icons.IconDetails,
                    breadcrumbs: true
                },
                // {
                //     id: 'sample-page6',
                //     title: 'Real-time monitoring',
                //     type: 'item',
                //     url: '/Real-time-monitoring',
                //     icon: icons.AutoModeIcon,
                //     breadcrumbs: true
                // },
                {
                    id: 'sample-page7',
                    title: 'Thresholds',
                    type: 'item',
                    url: '/Thresholds',
                    icon: icons.PrecisionManufacturingIcon,
                    breadcrumbs: true
                },
                {
                    id: 'sample-page8',
                    title: 'Alerts',
                    type: 'item',
                    url: '/Alerts',
                    icon: icons.SmartphoneIcon,
                    breadcrumbs: true
                },
            ]
        },


    ]

};

export default other;

// // assets
// import { CableIcon, IconDetails, IconTable } from '@tabler/icons';

// // constant
// const icons = { CableIcon, IconDetails, IconTable };

// // ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

// const other = {
//     id: 'sample-docs-roadmap',
//     type: 'group',
//     children: [
//         {
//             id: 'sample-page',
//             title: 'Dashboard',
//             type: 'collapse',
//             icon: icons.CableIcon,
//             breadcrumbs: true,
//         children: [
//             {
//                 id: 'sample-page',
//                 title: 'Dashboard',
//                 type: 'item',
//                  url: '/reusable',
//                 target: true
//             },
//                 {
//                     id: 'reusable',
//                     title: 'OffRoad Vehicle',
//                     type: 'item',
//                     url: '/reusable',
//                     target: true
//                 },
//             ]
//         }
//     ]
// };

// export default other;

